import { faBars, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ProjectWidgetPortrait } from "../../base/components/ProjectWidgetPortrait";
import ProjectWidgetRow from "../../base/components/ProjectWidgetRow";
import { cadDesign, productDesign } from "../../base/data/categories";
import { ProjectModel } from "../../base/models/projectModel";
import { fetchProjects } from "../../base/service/service";

export const ProductView = () => {
  const title = "Mobile & Web Applications";
  const [isPortrait, setIsPortrait] = useState<boolean>(true);
  const [projects, setProjects] = useState<ProjectModel[]>();

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchProjects({filterCategory: [cadDesign, productDesign ]});

      setProjects(data);
    };

    fetchData();
  }, []);
  return (
    <div className="inline-flex flex-col gap-5 text-justify w-full">
      <div>
        <div className="flex flex-row items-center justify-between">
          <h3 className="flex-1">{title}</h3>
          <div className="inline-flex flex-row gap-4">
            <span className="text-2xl cursor-pointer" onClick={() => setIsPortrait(false)}>
              <FontAwesomeIcon icon={faBars} />
            </span>

            <span className="text-2xl cursor-pointer" onClick={() => setIsPortrait(true)}>
              <FontAwesomeIcon icon={faGripVertical} />
            </span>
          </div>
        </div>
        <hr className="border-t border-black" />

        {isPortrait ? (
          <div className="my-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 self-center">
             {projects?.map((project) => (
              <ProjectWidgetPortrait key={project.key} project={project} />
            ))}
          </div>
        ) : (
          <div className="my-4 inline-flex flex-col w-full">
            {projects?.map((project) => (
              <ProjectWidgetRow key={project.key} project={project} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
